import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from "react-router-dom"
import { Auth0Provider } from "@auth0/auth0-react";
// import Modal from "react-modal";

// import { ChakraProvider } from '@chakra-ui/react';


// Modal.setAppElement("#root");

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    // <ChakraProvider>
    <BrowserRouter>
      <Auth0Provider
    domain="dev-oc5sv8wa1mdvaybx.us.auth0.com"
    clientId="fXl2d2AY1GOOn83M8j2RKytu0CfUdFO7"
    authorizationParams={{
      redirect_uri: window.location.origin
    }}
  >
    <App />
  </Auth0Provider>
    </BrowserRouter>,
    //  document.getElementById("root")
      // </ChakraProvider>
    
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
